module.exports = __webpack_public_path__ + "static/doordash-0406620dcf29a3bed7ffbbb023ce1928.png";